module.exports = __webpack_public_path__ + "img/0Q3A5798_L_Foamcore_MockedUp.f2c636ad.jpg";